export default () =>
  process.env.VUE_APP_API_URL != null ? process.env.VUE_APP_API_URL : "http://localhost:3030";
